import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useLocalization } from '../context/LocalizationContext';
import { Spinner } from 'react-bootstrap';

interface ProtectedRouteProps {
  component: React.ComponentType<any>;
  requiredRole?: string;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  component: Component,
  requiredRole,
}) => {
  const { isAuthenticated, user, isLoading } = useAuth();
  const { t } = useLocalization();

  if (isLoading) {
    return (
        <div className="app-startup-loading">
          <div className="app-startup-spinner-wrap">
            <Spinner animation="border" role="status" aria-label={t('loading')} />
            <span className="app-startup-label">{t('loading')}</span>
          </div>
        </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (requiredRole && user?.role !== requiredRole) {
    return <Navigate to="/" replace />;
  }

  return <Component />;
};

export default ProtectedRoute;
